import { TournamentDurationType } from '../enums';
import { T } from './translation-keys';

export const TournamentDurationTypeNames = {
  [TournamentDurationType.Daily]: T.DAILY,
  [TournamentDurationType.Weekend]: T.WEEKEND,
  [TournamentDurationType.Hourly]: T.HOURLY,
  [TournamentDurationType.Weekly]: T.WEEKLY
};
